import { useCallback, useEffect, useState } from "react"
import { Box } from "@mui/material"
import { usePointCloud } from "./use-point-cloud.jsx"

export const EditorPreview = ({ project }) => {
  const [potreeViewer, setPotreeViewer] = useState(null)
  const refCallback = useCallback((x) => {
    if (!x)
      return
    const viewer = new window.Potree.Viewer(
      x,
      {
        noDragAndDrop: true,
        noCameraAnimationHandles: true
      }
    )
    viewer.setEDLEnabled(false)
    viewer.setFOV(60)
    viewer.setPointBudget(10_000_000)
    viewer.setBackground("gradient")
    viewer.useHQ = false
    if (project.potreeProject)
      window.Potree.loadProject(viewer, project.potreeProject)
    for (const cameraAnimation of viewer.scene.cameraAnimations) {
      cameraAnimation.visible = false
    }
    setPotreeViewer(viewer)
  }, [])

  usePointCloud(
    potreeViewer,
    project.pointCloudUrl,
    project.name,
    true
  )

  useEffect(() => {
    return () => {
      return potreeViewer?.renderer?.dispose()
    }
  }, [potreeViewer])

  return <Box sx={{
    width: "100%",
    height: "100%",
    position: "relative"
  }} ref={refCallback}></Box>
}